import { useNavigate } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import {  useForm } from "react-hook-form";
import { toast } from "react-toastify";

import config from '../../Api/config'
import { useSession } from "../sessionProvider";
import { DatabaseProduct } from "../../Api/Database";
import ProductAccordion from "./productAccordion";
import useLazyLoader from "../../Api/lazyLoading";
import { useState } from "react";

import ReactGA from "react-ga4";

type FormInputs = {
    file: FileList, 
};

function MyProducts() {

    ReactGA.send({ hitType: "pageview", page: "/products", title: "Products" });

    const navigate = useNavigate();
    const {ownerId} = useSession();
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});
    const { formState: {errors}} = useForm<FormInputs>();
    const [registerProducts, setRegisterProducts] = useState(false);

    const {lazyLoadingRef, elements, end, loading, deleteElement} = useLazyLoader<DatabaseProduct, HTMLDivElement>({elementFetcher: (offset: string, limit: string) => {
        return config.API.getProducts(ownerId,"parent_list", "20", offset)
    }})
    
    async function deleteProduct(id?: string): Promise<boolean> {
        if(id) {
            const index = elements.findIndex((product) => {
                return product.id === id;
            })
            let delitedName = elements[index].title;

            try{
                const deleted = await config.API.deleteProduct(ownerId, id);
                if(deleted) {
                    // successfully deleted on API, delete in state
                    deleteElement(index);
                    notifySuccess("Removed product '"+ delitedName +"'.");
                }
                return deleted;
            } catch(e: any) {
                if(JSON.stringify(e).includes("fk__item_product_id")){
                    notifyError("Can't delete product that have DPPs registered on.");
                }else if(JSON.stringify(e).includes("fk__product_parent_id")){
                    notifyError("Can't delete product with registered variants. Remove variants before removing product.");
                    
                }else{
                    notifyError(JSON.stringify(e));
                }
            };
        }
        return false;
    }

    return(<>
        <div className="company" ref={lazyLoadingRef}>

            <RegisterVisual title={registerProducts ? "Register new product" : "My products"}/>

            <div className="explorer">

                {!registerProducts ? <>
                    <button className="btn btn-primary" onClick={() =>{setRegisterProducts(true)}}> New product</button>

                    { /* TODO SHOW ALL THE PRODUCTS */}
                    <div>
                        {elements.map((el, productIndex) => {
                            return(<ProductAccordion key={el.id} product={el} delete={(): Promise<boolean> => {
                                return deleteProduct(el.id)
                            }} />)
                        })}

                    </div>
                    {/*end && <><br></br><p>No more products</p></>*/}

                </>:<>
                    {/* Register button form */}

                    <button className="btn btn-primary" onClick={() =>{navigate("/register/product")}}>Create product</button>

                    {/* Variant creation only avaiable if owner have existing product */}
                    {elements.length > 0 && <>
                        <p className="separator">OR</p>
                        <button className="btn btn-primary" onClick={() => {navigate("/register/variant/")}}>Create product variant</button>
                    </>}
                    
                </>}
                
            </div>

            <Footer/>
        </div>
    </>)
}

export default MyProducts;